import "./Sparkles.scss";

type Sparkle = {
  id: number;
  left: string;
  top: string;
  size: string;
  thickness: string;
  delay: string;
  duration: string;
};

const sparkles: Sparkle[] = Array.from({ length: 360 }, (_, index) => ({
  id: index,
  left: `${Math.random() * 100}%`,
  top: `${Math.random() * 100}%`,
  size: `${8 + Math.random() * 22}px`,
  thickness: `${1 + Math.random() * 1.5}px`,
  delay: `${Math.random() * 8}s`,
  duration: `${2.5 + Math.random() * 4}s`,
}));

export const Sparkles = () => {
  return (
    <div className="sparkles" aria-hidden="true">
      {sparkles.map((sparkle) => (
        <span
          key={sparkle.id}
          className="sparkle"
          style={
            {
              left: sparkle.left,
              top: sparkle.top,
              width: sparkle.size,
              height: sparkle.size,
              animationDelay: sparkle.delay,
              animationDuration: sparkle.duration,
              "--sparkle-thickness": sparkle.thickness,
            } as React.CSSProperties
          }
        >
          <span className="sparkle-diagonal" />
        </span>
      ))}
    </div>
  );
};